import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { initialState } from '@/modules/marketplace/orders/store/initialState.ts'

const marketplaceOrdersSlice = createSlice({
  name: 'marketplaceOrders',
  initialState,
  reducers: {
    setFilters: (state, action: PayloadAction<string>) => {
      state.filters = action.payload
    },
    reset: () => initialState
  }
})

export const marketplaceOrdersActions = marketplaceOrdersSlice.actions
export const { reducer: marketplaceOrdersReducer } = marketplaceOrdersSlice
